const ENV_SHARED = {
    sentryDsn: 'https://5a47fb84b26d4bb98ac4e95478c5c05d@o354215.ingest.sentry.io/5868331',
    footerURL: 'https://content-bff-dev.public.zooplus.net/shop-footer/v1',
    staticPageGeneralURL: 'https://content-bff-dev.public.zooplus.net/static-page-general/v1',
};
const ENV_DEV = {
    ...ENV_SHARED,
    stage: 'dev',
};
const ENV_PROD = {
    ...ENV_SHARED,
    stage: 'prod',
    footerURL: 'https://content-bff.public.zooplus.net/shop-footer/v1',
    staticPageGeneralURL: 'https://content-bff.public.zooplus.net/static-page-general/v1',
};
const version = process.env.REACT_APP_VERSION;
process.env.REACT_APP_FA_PUBLIC_PATH ?? '/';
const getEnv = (stage) => {
    switch (stage) {
        case 'dev':
            return ENV_DEV;
        case 'prod':
        default:
            return ENV_PROD;
    }
};

export { getEnv, version };
//# sourceMappingURL=environment.js.map
